export interface ISimpleOrganization {
	readonly account: string;
	readonly id: string;
	readonly name: string;
	readonly server: string;
}

export class SimpleOrganization implements ISimpleOrganization {
	public get account(): string {
		return this.#account;
	}

	public get id(): string {
		return this.#id;
	}

	public get name(): string {
		return this.#name;
	}

	public get server(): string {
		return this.#server;
	}

	#account: string;
	#id: string;
	#name: string;
	#server: string;
	public constructor({ account, id, name, server }: ISimpleOrganization) {
		this.#account = account;
		this.#id = id;
		this.#name = name;
		this.#server = server;
	}
}
